import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=1b52b13d&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&id=1b52b13d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b52b13d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b52b13d')) {
      api.createRecord('1b52b13d', component.options)
    } else {
      api.reload('1b52b13d', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=1b52b13d&scoped=true&", function () {
      api.rerender('1b52b13d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/footer.vue"
export default component.exports